<template>
  <!-- 5-3 教育机构信息查看页面 -->
  <div class="main-box">
    <div class="main-box-all-css">
      <!-- 主要内容部分 -->
      <div class="main-box-css">
        <!-- 左边表单部分 -->
        <div class="left-box">
          <!-- 第一行 -->
          <div class="one-line">
            <div class="avatar">
              <img
                :src="address ? address : '@/assets/defaultImg.png'"
                @error="
                  e => {
                    e.target.src = require('@/assets/defaultImg.png');
                  }
                "
                alt=""
              />
            </div>
            <div class="institution-name">
              <div class="institution-box">
                <div class="institution-title">
                  {{
                    language == "ja-JP"
                      ? this.List.jpcertifiyStatus_dictText
                      : this.List.certifiyStatus_dictText
                  }}
                </div>
                <span>{{ $t("institutionName") }}</span>
                <el-tooltip
                  :content="institutionName"
                  placement="top"
                  v-if="institutionName"
                >
                  <p class="institution-main">
                    {{ institutionName }}
                  </p></el-tooltip
                >
              </div>
            </div>
          </div>
          <!-- 第二行 -->
          <div class="two-line">
            <div class="small-input-box">
              <span>{{ $t("postCode") }}</span>
              <p class="small-box-title" :title="postCode">{{ postCode }}</p>
            </div>
            <div class="big-input-box">
              <span>{{ $t("location") }}</span>
              <p class="small-box-title" :title="area">{{ area }}</p>
            </div>
          </div>
          <!-- 第三行 -->
          <div class="two-line">
            <div class="small-input-box">
              <span>{{ $t("institutionalAttributes") }}</span>

              <el-tooltip
                :content="
                  language == 'ja-JP'
                    ? this.List.jpattributes_dictText
                    : this.List.attributes_dictText
                "
                placement="top"
              >
                <p class="small-box-title">
                  {{
                    language == "ja-JP"
                      ? this.List.jpattributes_dictText
                      : this.List.attributes_dictText
                  }}
                </p></el-tooltip
              >
            </div>
            <div class="big-input-box">
              <span>{{ $t("hpOrSns") }}</span>
              <p class="small-box-title" :title="hPorSNS">{{ hPorSNS }}</p>
            </div>
          </div>
          <!-- 第四行 -->
          <div class="two-line">
            <div class="small-input-box">
              <span>{{ $t("representativeName") }}</span>
              <p class="small-box-title" :title="representativeName">
                {{ representativeName }}
              </p>
            </div>
            <div class="big-input-box">
              <span>{{ $t("institutionalNumber") }}</span>
              <p class="small-box-title" :title="phoneNumber">
                {{ phoneNumber }}
              </p>
            </div>
          </div>
          <!-- 第五行 -->
          <div class="two-line">
            <div class="small-input-box">
              <span>{{ $t("numberOfEmployees") }}</span>
              <p
                class="small-box-title"
                :title="
                  language == 'ja-JP'
                    ? this.List.jpteacherNumber_dictText
                    : this.List.teacherNumber_dictText
                "
              >
                {{
                  language == "ja-JP"
                    ? this.List.jpteacherNumber_dictText
                    : this.List.teacherNumber_dictText
                }}
              </p>
            </div>
            <div class="big-input-box">
              <span>{{ $t("studentNumber") }}</span>
              <p
                class="small-box-title"
                :title="
                  language == 'ja-JP'
                    ? this.List.jpstudentNumber_dictText
                    : this.List.studentNumber_dictText
                "
              >
                {{
                  language == "ja-JP"
                    ? this.List.jpstudentNumber_dictText
                    : this.List.studentNumber_dictText
                }}
              </p>
            </div>
          </div>
          <!-- 第六行 -->
          <div class="textarea-line">
            <div class="textarea-line-box">
              <span>{{ $t("businessContent") }}</span>
              <p class="textarea-css-main">{{ textData }}</p>
            </div>
          </div>
        </div>
        <!-- 右边表格部分 -->
        <div class="right-box">
          <el-table
            :data="tableData"
            :max-height="tableHeight"
            @row-click="rowClick"
          >
            <el-table-column type="selection" width="55"> </el-table-column>
            <el-table-column
              prop="name"
              label="学生氏名"
              width="100"
              :show-overflow-tooltip="true"
            >
              <template slot="header">
                <p>{{ $t("studentName") }}</p>
                <el-input
                  v-model="tableSearch1"
                  size="mini"
                  placeholder="Search"
                />
              </template>
            </el-table-column>
            <el-table-column prop="sex" label="性別" width="100">
              <template slot="header">
                <p>{{ $t("sex") }}</p>
                <el-input
                  v-model="tableSearch2"
                  size="mini"
                  placeholder="Search"
                />
              </template>
              <template slot-scope="scope">
                <span v-if="language === 'ja-JP'">{{
                  scope.row.jpsex_dictText
                }}</span>
                <span v-else>{{ scope.row.sex_dictText }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="birth" label="生年月日" width="110">
              <template slot="header">
                <p>{{ $t("birth") }}</p>
                <el-input
                  v-model="tableSearch3"
                  size="mini"
                  placeholder="Search"
                />
              </template>
              <template slot-scope="scope">
                <span>{{ scope.row.birth.split(" ")[0] }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="education"
              width="120"
              :show-overflow-tooltip="true"
              label="学歴"
            >
              <template slot="header">
                <p>{{ $t("education") }}</p>
                <el-input
                  v-model="tableSearch4"
                  size="mini"
                  placeholder="Search"
                />
              </template>
              <template slot-scope="scope">
                <span v-if="language === 'ja-JP'">{{
                  scope.row.jpeducation_dictText
                }}</span>
                <span v-else>{{ scope.row.education_dictText }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="profession" label="専攻" width="120">
              <template slot="header">
                <p>{{ $t("major") }}</p>
                <el-input
                  v-model="tableSearch5"
                  size="mini"
                  placeholder="Search"
                />
              </template>
            </el-table-column>
            <el-table-column prop="japanese" width="120" label="日本語">
              <template slot="header">
                <p>{{ $t("japanese") }}</p>
                <el-input
                  v-model="tableSearch6"
                  size="mini"
                  placeholder="Search"
                />
              </template>
              <template slot-scope="scope">
                <span v-if="language === 'ja-JP'">{{
                  scope.row.jpjapanese_dictText
                }}</span>
                <span v-else>{{ scope.row.japanese_dictText }}</span>
              </template>
            </el-table-column>
          </el-table>
          <!-- 分页部分 -->
          <div class="pagination-table">
            <el-pagination
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-size="tableSize"
              layout=" prev, pager, next"
              :total="total"
              class="pagination"
            >
            </el-pagination>
            <span class="per-page">Rows per page</span>
            <el-dropdown @command="handleCommand">
              <span class="el-dropdown-link">
                {{ tableSize }}
                <i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="a">5</el-dropdown-item>
                <el-dropdown-item command="b">10</el-dropdown-item>
                <el-dropdown-item command="c">15</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
      </div>
      <!-- button -->
      <div class="main-button-box">
        <button @click="toEdit">{{ $t("toEdit") }}</button>
      </div>
    </div>
  </div>
</template>
<script>
import {
  educationalInstitutionDisplay,
  getUrlFromOSS,
  queryBasicInfo
} from "../../js/api";
import AES from "../../js/AES";
import axios from "axios";
export default {
  name: "educationalInstitutionInformation",
  components: {},
  data() {
    return {
      List: "",
      //table数据
      tableData: [],
      tableSize: 5,
      currentPage: 1,
      total: 0,
      institutionName: "", //左边機関名
      postCode: "", //左边郵便番号
      area: "", //左边所在地
      agencyAttribute: "", //左边機関属性
      hPorSNS: "", //左边HP or SNS
      representativeName: "", //左边代表者氏名
      phoneNumber: "", //左边機関の電話番号
      numberEmployees: "", //左边授業員数
      studentNumber: "", //左边学生人数
      textData: "", //左边事業内容
      educationId: "",
      tableSearch1: "", //table学生氏名
      tableSearch2: "", //table性別
      tableSearch3: "", //table生年月日
      tableSearch4: "", //table学歴
      tableSearch5: "", //table専攻
      tableSearch6: "", //table日本語
      totalItem: 0,
      address: null,
      language: "",
      tableHeight: "" //表格高度
    };
  },
  created() {
    this.language = this.$i18n.locale;
    this.getList();
    this.getTableHeight();
  },
  //qaq
  mounted() {
    window.addEventListener("setItemEvent", this.languageChange, true);
    let _this = this;
    window.onresize = () => {
      if (_this.resizeFlag) {
        clearTimeout(_this.resizeFlag);
      }
      _this.resizeFlag = setTimeout(() => {
        _this.getTableHeight();
        _this.resizeFlag = null;
      }, 100);
    };
  },
  destroyed() {
    window.removeEventListener("setItemEvent", this.languageChange, true);
  },
  computed: {},
  methods: {
    getTableHeight() {
      let tableH = 230; //距离页面下方的高度
      let tableHeightDetil = window.innerHeight - tableH;
      if (tableHeightDetil <= 200) {
        this.tableHeight = 200;
      } else {
        this.tableHeight = window.innerHeight - tableH;
      }
    },
    fuzzy() {},
    languageChange(e) {
      const that = this;
      console.log("------监听数据2------");
      console.log(e);
      if (e.key && e.key == "language" && e.newValue) {
        that.language = that.$i18n.locale;
        that.getList();
      }
    },
    //接口 获取表格数据
    getList() {
      queryBasicInfo()
        .then(res => {
          console.log("select获取表格数据");
          console.log(res);
          if (res.data.code === "A0000") {
            let aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            aesFecInfo = aesFecInfo.data[0];
            this.institutionName = aesFecInfo.educationName; //機関名
            this.postCode = aesFecInfo.postNumber; //郵便番号
            this.area = aesFecInfo.address; //所在地
            this.agencyAttribute = aesFecInfo.attributes; //機関属性
            this.hPorSNS = aesFecInfo.hpOrSns; //HP or SNS
            this.representativeName = aesFecInfo.legalPerson; //代表者氏名
            this.phoneNumber = aesFecInfo.telephone; //機関の電話番号
            this.numberEmployees = aesFecInfo.teacherNumber; //授業員数
            this.studentNumber = aesFecInfo.studentNumber; //学生人数
            this.textData = aesFecInfo.introduction; //事業内容
            this.educationId = aesFecInfo.educationId;
            this.getUrlList(aesFecInfo.avatarAddress);
            this.getList1();
          }
        })
        .catch(res => {});
    },
    getList1() {
      //右侧数据获取
      console.log("右侧数据获取");
      var fakeInfo2 = {
        educationId: this.educationId,
        pageNumber: this.currentPage,
        pageSize: this.tableSize
      };
      educationalInstitutionDisplay(fakeInfo2)
        .then(res2 => {
          console.log("--------学生信息获取--------");
          console.log(res2);
          if (res2.data.code === "A0000") {
            const aesFecInfo2 = JSON.parse(AES.decrypt(res2.data.data));
            console.log("输出");
            console.log(aesFecInfo2.data2);
            this.List = aesFecInfo2.data1[0];
            this.tableData = aesFecInfo2.data2;
            this.total = aesFecInfo2.total2;
            console.log(aesFecInfo2);
          } else {
            this.$message.error("登录失败。");
          }
        })
        .catch(res => {});
    },

    handleCurrentChange(val) {
      this.currentPage = val;
      this.getList1();
    },
    //图片回显
    getUrlList(url) {
      console.log("url" + url);
      var fakeInfo = {
        message: url
      };
      getUrlFromOSS(fakeInfo)
        .then(res => {
          if (res.data.code === "200 OK") {
            console.log("图片回显接口1");
            console.log(res);
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            console.log(aesFecInfo.message);
            this.address = aesFecInfo.message;
          } else {
            console.log(res);
          }
        })
        .catch(() => {});
    },
    //分页条数
    handleCommand(command) {
      if (command === "a") {
        this.tableSize = 5;
      } else if (command === "b") {
        this.tableSize = 10;
      } else {
        this.tableSize = 15;
      }
      this.currentPage = 1;
      this.getList1();
    },
    // 编辑跳转页面
    toEdit() {
      this.$router.push({
        path: "/educationalCertificationRevise"
      });
    },
    //行点击
    rowClick(row) {
      console.log(row.name);
      console.log("行点击事件");
      this.$router.push({
        path: "/educationalInstitutionsTalentApplicationList",
          name: "educationalInstitutionsTalentApplicationList",
        params: { row: row }
      });
    }
  }
};
</script>
<style scoped>
.main-box {
  width: 100%;
  height: 100%;
  background: #fff;
}

.main-box-css {
  display: flex;
  padding-top: 50px;
  /* height: 50px; */
  width: 1050px;
  background: #fff;
  margin: auto;
}

.main-box-all-css {
  /* width: 1100px; */
  margin: 0 auto;
  padding-left: 30px;
  padding-right: 30px;
  box-sizing: border-box;
  margin-bottom: 80px;
}

.left-box {
  width: 500px;
  height: 100%;

  background: #fff;
  margin-bottom: 80px;
}

.one-line {
  height: 160px;
  display: flex;
}

.avatar {
  width: 150px;
  height: 150px;
  border-radius: 50%;
}

.avatar img {
  width: 150px;
  height: 150px;
}

.institution-name {
  height: 150px;
  flex: 1;
}

.institution-box {
  width: 300px;
  height: 57px;
  background: #ffffff;
  border: 2px solid #51abff;
  box-sizing: border-box;
  border-radius: 8px;
  margin-left: 35px;
  position: relative;
  margin-top: 70px;
  float: right;
}

.institution-title {
  background: #fc630c;
  border-radius: 4px;
  height: 16px;
  width: 49px;
  font-family: "Work Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 10px;
  line-height: 16px;
  letter-spacing: -0.02em;
  color: #ffffff;
  text-align: center;
  position: absolute;
  top: -22px;
  right: 0;
}

.institution-box span {
  position: absolute;
  display: inline-block;
  padding: 0 5px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  top: -12px;
  left: 15px;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: #51abff;
  background: #ffffff;
}

.institution-main {
  margin-top: 15px;
  height: 25px;
  padding: 0 20px;
  /* -webkit-box-sizing: border-box; */
  box-sizing: border-box;
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  color: #686868;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.two-line {
  height: 50px;
  margin-top: 15px;
  display: flex;
}

.small-input-box {
  width: 200px;
  height: 44px;
  background: #ffffff;
  border: 2px solid #51abff;
  box-sizing: border-box;
  border-radius: 8px;
  position: relative;
}

.small-input-box span {
  position: absolute;
  top: -12px;
  left: 15px;
  display: inline-block;
  height: 24px;
  padding: 0 5px;
  background: #ffffff;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: #51abff;
  z-index: 10;
}

.small-box-title {
  margin-top: 12px;
  padding-left: 20px;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #686868;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.big-input-box {
  width: 290px;
  height: 44px;
  background: #ffffff;
  border: 2px solid #51abff;
  box-sizing: border-box;
  border-radius: 8px;
  position: relative;
  margin-left: 10px;
}

.big-input-box span {
  position: absolute;
  top: -12px;
  left: 15px;
  display: inline-block;
  height: 24px;
  padding: 0 5px;
  background: #ffffff;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: #51abff;
  z-index: 10;
}

.big-input-box /deep/ .el-input {
  height: 38px;
  border: 1px solid transparent;
  box-sizing: border-box;
}

.big-input-box /deep/ .el-input__inner {
  height: 38px;
  border: 1px solid transparent;
  box-sizing: border-box;
}

.inline-box-dropdown {
  height: 38px;
  width: 180px;
  margin-top: 2px;
  margin-left: 10px;
}

.inline-box-dropdown /deep/ .el-dropdown {
  height: 38px;
  width: 180px;
}

.inline-box-dropdown /deep/ .el-dropdown-link {
  height: 38px;
  line-height: 38px;
  width: 170px;
  position: static;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  letter-spacing: 0.25px;
  color: #686868;
}

.inline-box-dropdown /deep/ .el-icon-arrow-down {
  float: right;
  line-height: 38px;
}

.small-dropdown {
  width: 140px;
  height: 44px;
  background: #ffffff;
  border: 2px solid #51abff;
  box-sizing: border-box;
  border-radius: 8px;
  position: relative;
  margin-left: 10px;
}

.small-dropdown span {
  position: absolute;
  top: -12px;
  left: 15px;
  display: inline-block;
  height: 24px;
  padding: 0 5px;
  background: #ffffff;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: #51abff;
  z-index: 10;
}

.small-dropdown /deep/ .el-dropdown {
  height: 38px;
  width: 110px;
}

.small-dropdown /deep/ .el-dropdown-link {
  height: 38px;
  line-height: 38px;
  width: 110px;
  position: static;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  letter-spacing: 0.25px;
  color: #686868;
}

.small-dropdown /deep/ .el-icon-arrow-down {
  float: right;
  line-height: 38px;
}

.inline-box-dropdown1 {
  height: 38px;
  width: 110px;
  margin-top: 2px;
  margin-left: 10px;
}

.textarea-line {
  margin-top: 15px;
  width: 500px;
  height: 180px;
}

.textarea-line-box {
  width: 500px;
  height: 178px;
  background: #ffffff;
  border: 2px solid #51abff;
  box-sizing: border-box;
  border-radius: 8px;
  position: relative;
}

.textarea-line-box span {
  position: absolute;
  top: -12px;
  left: 15px;
  display: inline-block;
  height: 24px;
  padding: 0 5px;
  background: #ffffff;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: #51abff;
  z-index: 10;
}

.right-box {
  width: 500px;
  margin-left: 20px;
  height: 100%;
  padding-top: 70px;
  box-sizing: border-box;
}

.right-box /deep/ .el-input__inner {
  border: 1px solid transparent;
  padding: 0;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #c9cfda;
  text-align: center;
}

.right-box .empty {
  height: 30px;
}

.right-box /deep/ .cell {
  text-align: center;
}

.right-box /deep/ .caret-wrapper {
  position: absolute;
  top: -4px;
  right: 20px;
}

.empty-ps {
  position: relative;
}

.pagination-table {
  display: flex;
  height: 40px;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 40px;
  letter-spacing: 0.25px;
  color: #454d59;
  margin-top: 10px;
  align-items: center;
  justify-content: right;
}

.pagination-table /deep/ .el-dropdown {
  background: #ffffff;
  width: 60px;
  line-height: 24px;
  height: 24px;
  border: 1px solid #b0bac9;
  box-sizing: border-box;
  margin-left: 10px;
}

.pagination-table /deep/ .el-dropdown-link {
  width: 60px;
  height: 24px;
  padding-left: 10px;
  box-sizing: border-box;
  display: inline-block;
}

.pagination-table /deep/ .el-icon-arrow-down {
  float: right;
  line-height: 24px;
  margin-right: 5px;
}

.pagination {
  margin-top: 10px;
}

.per-page {
  margin-left: 20px;
}

.main-button-box {
  text-align: center;
  width: 500px;
  margin: auto;
}

.main-button-box button {
  width: 152px;
  height: 40px;
  background: #fc630c;
  border-radius: 4px;
  font-family: "Poppins";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  color: #ffffff;
  cursor: pointer;
}

.textarea-css-main {
  width: 99%;
  height: 99%;
  margin-left: 1px;
  margin-top: 1px;
  border-radius: 8px;
  padding: 15px 5px 5px 20px;
  box-sizing: border-box;
}

.table-img-css {
  border-radius: 50%;
}
</style>



// WEBPACK FOOTER //
// src/pages/educationalInstitutionInformation/index.vue